"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('setBlockedDomainsOption')(function setBlockedDomainsOption(blockedSenders, state) {
    var optionState = state.optionState;
    optionState.blockedDomains = blockedSenders;
}));
//# sourceMappingURL=setBlockedDomainsOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-blocked-domains-option/lib/actions/setBlockedDomainsOption.js
// module id = 5031
// module chunks = 2